import { Button, Input, notification, Spin } from 'antd';
import { useState } from 'react';
import { Dynamics } from '@/services/dynamics/dynamics';
import { entityFields } from '@/components/CallPanel/config';
import { LoadingOutlined } from '@ant-design/icons';
import './Forms.scss';
import {
  getFieldValidationConfigForObject,
  validateFormData,
  getErrorIfNotValid,
} from './FormValidationConfig';

const antIcon = <LoadingOutlined spin />;
const FIELD_VALIDATION_CONFIG = getFieldValidationConfigForObject('Contact');
interface IProps {
  setUnsavedFormData: (data: any) => void;
  data: any;
  prefilledPhone: string;
}

export const NewContactForm = ({
  setUnsavedFormData,
  data,
  prefilledPhone,
}: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notificationApi, contextHolder] = notification.useNotification();
  const [formData, setFormData] = useState(
    data?.Contact || {
      firstName: '',
      lastName: '',
      email: '',
      businessPhone: '',
      mobilePhone: prefilledPhone,
    },
  );

  const [formDataErrors, setFormDataErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    businessPhone: '',
    mobilePhone: '',
  });

  const changeValue = (item: string) => {
    return (e) => {
      setUnsavedFormData({
        Contact: {
          ...formData,
          [item]: e.target.value,
        },
      });
      setFormData({
        ...formData,
        [item]: e.target.value,
      });
      setFormDataErrors({
        ...formDataErrors,
        [item]: getErrorIfNotValid(
          e.target.value,
          FIELD_VALIDATION_CONFIG[item],
        ),
      });
    };
  };

  const validate = () => {
    const errors = {
      firstName: '',
      lastName: '',
      email: '',
      businessPhone: '',
      mobilePhone: '',
    };

    const isOk = validateFormData(formData, errors, FIELD_VALIDATION_CONFIG);
    setFormDataErrors(errors);
    return isOk;
  };

  const showRes = async () => {
    const data = {
      firstname: formData.firstName?.trim(),
      lastname: formData.lastName?.trim(),
      fullname: `${formData.firstName?.trim()} ${formData.lastName?.trim()}`,
      emailaddress1: formData.email?.trim(),
      telephone1: formData.businessPhone?.trim(),
      mobilephone: formData.mobilePhone?.trim(),
    };
    const isValid = validate();
    if (isValid) {
      setIsLoading(true);
      await Dynamics.saveNewEntity('contact', data);
      setIsLoading(false);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        businessPhone: '',
        mobilePhone: '',
      });
      setUnsavedFormData(null);
      setTimeout(() => {
        notificationApi.success({
          message: 'Contact successfully created',
          placement: 'bottomRight',
          duration: 3,
          className: 'notifications',
        });
      }, 0);
    }
  };
  return isLoading ? (
    <Spin className="spinner" indicator={antIcon} />
  ) : (
    <div>
      {contextHolder}
      <p className="heading">Fill in the form</p>
      <div className="form-container">
        {Object.keys(entityFields.contact).map((item) => {
          return (
            <div key={item} className="line">
              {entityFields.contact[item]}
              <Input
                placeholder={entityFields.contact[item]}
                value={formData[item]}
                onChange={changeValue(item)}
                status={formDataErrors[item] ? 'error' : ''}
              />
              {formDataErrors[item] ? (
                <div className="form-error">{formDataErrors[item]}</div>
              ) : (
                <></>
              )}
            </div>
          );
        })}
      </div>
      <div className="button-block">
        <Button onClick={showRes} data-testid="create-contact">
          Submit
        </Button>
      </div>
    </div>
  );
};
